import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload, UserPlus } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { api } from "../../lib/api";
import { insApi, errMsg } from "../../lib/insApi";

export const BorderEmployeeForm = ({ kind, onDone }) => {
  const [f, setF] = useState({ name: "", border_number: "", nationality: "", birth_date: "", passport_number: "", passport_expiry: "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async () => {
    setBusy(true);
    try {
      const att = file ? await api.uploadFile(file) : {};
      const emp = await insApi.borderEmployee({ ...f, attachment_id: att.attachment_id || "", attachment_name: att.attachment_name || "",
        vehicle_type: kind === "cars" ? "سيارة" : kind === "moto" ? "دراجة نارية" : "" });
      toast.success(`تمت إضافة ${emp.name} كموظف جديد برقم الحدود`);
      onDone({ ...emp, birth_date: f.birth_date, nationality: f.nationality });
    } catch (e) { toast.error(errMsg(e, "تعذّرت الإضافة")); } finally { setBusy(false); }
  };
  const ok = f.name.trim().length > 1 && /^\d{10}$/.test(f.border_number.trim());
  return (
    <div className="space-y-2 rounded-xl border border-emerald-200 bg-emerald-50/40 p-3" data-testid="border-emp-form">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-emerald-900"><UserPlus className="h-4 w-4" /> موظف جديد برقم الحدود (ينضاف لقائمة الموظفين)</p>
      <div className="grid gap-2 sm:grid-cols-2">
        <Input data-testid="border-emp-name" placeholder="الاسم كما في الجواز" value={f.name} onChange={set("name")} />
        <Input data-testid="border-emp-number" dir="ltr" inputMode="numeric" maxLength={10} placeholder="رقم الحدود (10 أرقام)" value={f.border_number} onChange={set("border_number")} />
        <Input data-testid="border-emp-nationality" placeholder="الجنسية" value={f.nationality} onChange={set("nationality")} />
        <label className="text-xs text-slate-500">تاريخ الميلاد<Input data-testid="border-emp-birth" type="date" value={f.birth_date} onChange={set("birth_date")} /></label>
        <Input data-testid="border-emp-passport" dir="ltr" placeholder="رقم الجواز" value={f.passport_number} onChange={set("passport_number")} />
        <label className="text-xs text-slate-500">انتهاء الجواز<Input data-testid="border-emp-passport-expiry" type="date" value={f.passport_expiry} onChange={set("passport_expiry")} /></label>
      </div>
      <label className="flex cursor-pointer items-center gap-2 rounded-lg border border-dashed border-emerald-300 bg-white px-3 py-2 text-sm text-slate-600" data-testid="border-emp-file-label">
        <Upload className="h-4 w-4 text-emerald-600" /> {file ? file.name : "إرفاق ملف الجواز (PDF أو صورة)"}
        <input data-testid="border-emp-file" type="file" accept="application/pdf,image/*" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} />
      </label>
      <Button data-testid="border-emp-save" disabled={!ok || busy} onClick={save} className="w-full gap-1.5 bg-emerald-700 hover:bg-emerald-800">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <UserPlus className="h-4 w-4" />} إضافة وتحديد للتأمين</Button>
    </div>
  );
};
